module.exports = __webpack_public_path__ + "img/live_conference.cd273583.svg";